import { Tune } from "@mui/icons-material";
import { FC, useRef } from "react";
import UserMenuItem from "./UserMenuItem";
import { DialogHandle } from "../Dialog/DialogTypes";
import ReportPreferencesDialog from "./ReportPreferencesDialog";

const CommunicationPreferencesItem: FC<{ onClose: () => void }> = ({
  onClose,
}) => {
  const preferencesDialog = useRef<DialogHandle>(null);
  function showPreferences() {
    preferencesDialog.current?.show();
  }

  return (
    <>
      <UserMenuItem Icon={Tune} onClick={showPreferences}>
        Report Preferences
      </UserMenuItem>

      <ReportPreferencesDialog ref={preferencesDialog} onClose={onClose} />
    </>
  );
};

export default CommunicationPreferencesItem;
